import { useAppSelector } from '@core/js/store/hooks';
import { prop } from 'ramda';

export const useGetGreenTubeAndSkyWindEnablad = () => {
    const dynamicTags = useAppSelector(prop('dynamicTags'));
    const enabledRegexp = new RegExp('true');
    const showGreenTubeJackpots = enabledRegexp.test(dynamicTags.DTAG_IS_GREEN_TUBE_ENABLED);
    const showSkyWindJackpots = enabledRegexp.test(dynamicTags.DTAG_IS_SKY_WIND_ENABLED);

    return {
        showGreenTubeJackpots,
        showSkyWindJackpots
    };
};
